import React, { createContext, useContext, useState } from 'react'

export const toastContext = createContext(null);

export function ToastProvider({ children }) {
    const [message, setMessage] = useState("");
    const [role, setRole] = useState("");
    const [showToast, setShowToast] = useState(false)

    const handleToastData = (message, role) => {
        setMessage(message)
        setRole(role)
        setShowToast(true)
    };

    const handleHideToast = () => {
        setShowToast(false)
    }

    return (
        <toastContext.Provider value={{ message, showToast, role, handleHideToast, handleToastData }}>
            {children}
        </toastContext.Provider>
    )
}

export function useToast() {
    return useContext(toastContext);
}